(function ($) {
  let postsArray = [];
  async function getDataInstagramFeed() {
    let response;
    let data;
    try {
      response = await fetch("/apps/insta-feed");
      data = await response.json();
      //split data in max 8 posts
      data = data.slice(0, 8);
      return data;
    } catch (error) {
      console.log(
        "There is an error with Instagram Feed Images API fetch: ",
        error,
      );
      $(".insta-feed-container").css("display", "none");
      return false;
    }
  }

  //photo or video post
  const mediaHtml = (media_url, caption) => {
    const alt = caption
      .slice(0, 100)
      .replace(/\p{Emoji_Presentation}|[^0-9a-z-A-Z ]/gu, "")
      .trim();

    if (media_url.includes(".mp4")) {
      return `<video class="insta-feed-img" video loop muted playsinline autoplay width="640" height="799">
      <source src="${media_url}" type="video/mp4" />
      Your browser does not support the video tag.
      </video>`;
    }
    return `<img class="insta-feed-img" src="${media_url}" alt="${alt}" width="640" height="799" />`;
  };

  function htmlGenerate(caption, date, mediaurl, href) {
    return `<div class="insta-feed-img-container col-8 col-sm-4 col-md-4 col-lg-2">
    <a href="${href}" target="_blank">
      <div class="insta-feed-container-overlay">
      ${mediaHtml(mediaurl, caption)}
      <div class="insta-feed-overlay">
      <p class="insta-feed-overlay-text">${caption}</p>
      <p class="insta-feed-overlay-date">${date}</p>
      </div>
      </div>
      </a>
    </div>`;
  }

  async function main() {
    postsArray = await getDataInstagramFeed();
    if (!postsArray) {
      return;
    }

    for (const item of postsArray) {
      $(".insta-feed-selector").append(
        htmlGenerate(item.caption, item.date, item.media_url, item.permalink),
      );
    }
  }
  main();
})(jQuery);
